/* eslint-disable import/prefer-default-export */

export const PAGE_SIZE = 50;
export const ROW_HEIGHT = 30;
